<div class="dynamic-field form-select" [formGroup]="group">
  <mat-form-field appearance="outline" class="select">
    <mat-label>{{ config.label }}</mat-label>

    <mat-select
      [formControlName]="config.name"
      [multiple]="isMultipleSelect"
      [compareWith]="compareFn"
      (selectionChange)="onChange($event)"
      [disabled]="!!config.disabled"
      >

      <!-- Campo de pesquisa-->
      <div class="mat-select-search-wrapper">
        <input 
          class="mat-select-search-input"
          [formControl]="optionFilterCtrl" 
          placeholder="Pesquisar..." 
          (click)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()">
      </div>

      <mat-option *ngIf="(filteredOptions | async)?.length === 0" disabled>
        Nenhum resultado encontrado
      </mat-option>

      
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        <span *ngIf="config.displayValue">{{ config.displayValue(option) }}</span>
        <span *ngIf="!config.displayValue && config.display">{{ option[config.display] }}</span>
        <span *ngIf="!config.displayValue && !config.display">{{ option }}</span>
      </mat-option>
    </mat-select>

    <mat-error *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
      <span>Campo Obrigatório</span>
    </mat-error>
  </mat-form-field>
</div>
